// src/ListGyms.js
import React, { useEffect, useState } from 'react';
import { listGyms } from '../api';

const ListGyms = () => {
  const [gyms, setGyms] = useState([]);

  useEffect(() => {
    const fetchGyms = async () => {
      try {
        const response = await listGyms();
        setGyms(response.data);
      } catch (error) {
        console.error('Impossible de récupérer les salles :', error.response?.data || error);
      }
    };

    fetchGyms();
  }, []);

  return (
    <div>
      <h2>Liste des salles</h2>
      <ul>
        {gyms.map((gym) => (
          <li key={gym.gym_code}>{gym.name}</li>
        ))}
      </ul>
    </div>
  );
};

export default ListGyms;
